import { range } from "../utils";
var timePattern = /^(?<hours>[0-9]{2}):(?<minutes>[0-9]{2})$/;
export function getCurrentDate() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
export function getCalendarPage(year, month) {
    var firstDayOfMonth = new Date(year, month).getDay() || 7;
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var currentMonthDays = Array.from(range(1, daysInMonth), function (day) { return ({
        day: day,
        currentMonth: true,
    }); });
    var daysInPrevMonth = new Date(year, month, 0).getDate();
    var prevMonthDays = firstDayOfMonth !== 1
        ? Array.from(range(daysInPrevMonth - firstDayOfMonth + 2, daysInPrevMonth), function (day) { return ({ day: day, currentMonth: false }); })
        : [];
    var calendarPage = prevMonthDays.concat(currentMonthDays);
    var weeksInCalendarPage = 6;
    var daysInCalendarPage = 7 * weeksInCalendarPage;
    var nextMonthDays = calendarPage.length < daysInCalendarPage
        ? Array.from(range(1, daysInCalendarPage - calendarPage.length), function (day) { return ({
            day: day,
            currentMonth: false,
        }); })
        : [];
    return calendarPage.concat(nextMonthDays);
}
export function getTimeStampInSecs(datetime) {
    return Math.floor(datetime.getTime() / 1000);
}
export function isSameDay(firstDate, secondDate) {
    if (!firstDate || !secondDate)
        return false;
    return (firstDate.getFullYear() === secondDate.getFullYear() &&
        firstDate.getMonth() === secondDate.getMonth() &&
        firstDate.getDate() === secondDate.getDate());
}
export function isWeekend(day) {
    var weekDay = day.getDay();
    return weekDay === 0 || weekDay === 6;
}
export function isDayWithinRange(dateToCheck, startDate, endDate) {
    var isOverStartDate = true;
    if (startDate) {
        startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        isOverStartDate = dateToCheck >= startDate;
    }
    var isLessThanEndDate = true;
    if (endDate) {
        endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59);
        isLessThanEndDate = dateToCheck <= endDate;
    }
    return isOverStartDate && isLessThanEndDate;
}
export function combineDateAndTime(date, time) {
    var datetime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var _a = timePattern.exec(time).groups, hours = _a.hours, minutes = _a.minutes;
    datetime.setHours(+hours);
    datetime.setMinutes(+minutes);
    return datetime;
}
export function formatDate(date) {
    var formatDigits = function (digits) { return digits.toString().padStart(2, "0"); };
    var day = formatDigits(date.getDate());
    var month = formatDigits(date.getMonth() + 1);
    var year = date.getFullYear().toString().slice(-2);
    return "".concat(day, ".").concat(month, ".").concat(year);
}
export var monthNames = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
];
export var dayNames = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
export function isTimeValid(time) {
    return timePattern.test(time);
}
export function getDateFrom(timestampInSecs) {
    return new Date(timestampInSecs * 1000);
}
export function formatDateRelative(date, contractedForm) {
    if (contractedForm === void 0) { contractedForm = false; }
    var now = new Date();
    var options = {
        hour: "numeric",
        minute: "numeric",
    };
    if (!isSameDay(now, date)) {
        options.day = "numeric";
        options.month = "long";
    }
    if (now.getFullYear() !== date.getFullYear()) {
        options.year = "numeric";
        if (contractedForm) {
            delete options.hour;
            delete options.minute;
        }
    }
    var dateFormatter = new Intl.DateTimeFormat("ru", options);
    return dateFormatter.format(date).replace(",", "");
}
